import styled from 'styled-components';

import { COLORS } from '@/nova/theme/tokens';
import { AddBtn, PreviewBtn } from '../CarouselCuration/CarouselCuration.styles';

/** A list's actions' height on its row: about a line of their 13px copy and AddBtn's 9px padding and 1px border either
 *  side, set rather than left to the font so the round ones match the labelled one beside them. */
const ACTION_PX = 36;

/* Hide list / Show list and Configure list, their glyphs alone (their names their tooltips), and Preview on site so too
   when the row is short of room: AddBtn's ring, round, as tall as Preview on site beside them. */
export const GlyphBtn = styled(AddBtn)<{ $on?: boolean }>`
  box-sizing: border-box;
  flex: none;
  justify-content: center;
  width: ${ACTION_PX}px;
  height: ${ACTION_PX}px;
  padding: 0;
  gap: 0;
  /* A toggle that is on (a hidden list's eye) holds a tint of its ring, stronger than AddBtn's hover one so it reads as a
     switch on a dark theme too (the user, 2026-10-21). */
  ${({ $on }) => ($on ? `background: color-mix(in srgb, ${COLORS.ctaBorder} 30%, transparent);` : '')}
`;

/* Preview on site, labelled, at the row's height. */
export const RowPreviewBtn = styled(PreviewBtn)`
  height: ${ACTION_PX}px;
  padding-top: 0;
  padding-bottom: 0;
`;
